import { Component } from '@angular/core';
import { PillButtonComponent } from '../../shared/ui/pill-button/pill-button.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [PillButtonComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly year = new Date().getFullYear();
}
